import './RadioButton.less';
import React, { EventHandler, FC } from 'react';
import BlueRadioIcon from '../../icons/svg/blue-radio-sv.svg';
import clsx from 'clsx';

const RadioButton: FC<{
    active?: boolean;
    className?: string;
    onClick?: EventHandler<any>;
    dataAtid?: string;
    disabled?: boolean;
}> = ({ active, className, onClick, children, dataAtid, disabled }) => (
    <div
        className={clsx('nui-radio-button nui-radio-label', className, {
            active,
            disabled: disabled && !active,
            'active-disabled': disabled && active
        })}
        onClick={onClick ? onClick : null}
        data-atid={dataAtid}
    >
        <BlueRadioIcon />
        {children}
    </div>
);

export default RadioButton;
